import { Shield, Lock, CreditCard, Award, CheckCircle } from "lucide-react";

const TrustBadges = () => {
  // Payment network badge component using styled text
  const PaymentBadge = ({ name, bgClass }: { name: string; bgClass: string }) => (
    <div className={`px-3 py-1.5 rounded-md font-bold text-xs tracking-wide ${bgClass}`}>
      {name}
    </div>
  );

  return (
    <section className="py-12 bg-muted/30 border-y border-border">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12">
          {/* PCI Compliance */}
          <div className="flex items-center gap-3 text-muted-foreground">
            <div className="p-2 rounded-lg bg-accent/10">
              <Shield className="h-6 w-6 text-accent" />
            </div>
            <div>
              <p className="font-semibold text-foreground text-sm">PCI DSS</p>
              <p className="text-xs">Compliant</p>
            </div>
          </div>

          {/* SSL Secured */}
          <div className="flex items-center gap-3 text-muted-foreground">
            <div className="p-2 rounded-lg bg-accent/10">
              <Lock className="h-6 w-6 text-accent" />
            </div>
            <div>
              <p className="font-semibold text-foreground text-sm">256-bit SSL</p>
              <p className="text-xs">Encryption</p>
            </div>
          </div>

          {/* Payment Networks - Using styled text badges */}
          <div className="flex items-center gap-2">
            <PaymentBadge name="VISA" bgClass="bg-[#1A1F71] text-white" />
            <PaymentBadge name="MASTERCARD" bgClass="bg-gradient-to-r from-[#EB001B] to-[#F79E1B] text-white" />
            <PaymentBadge name="AMEX" bgClass="bg-[#006FCF] text-white" />
            <PaymentBadge name="DISCOVER" bgClass="bg-[#FF6000] text-white" />
          </div>

          {/* Years in Business */}
          <div className="flex items-center gap-3 text-muted-foreground">
            <div className="p-2 rounded-lg bg-accent/10">
              <Award className="h-6 w-6 text-accent" />
            </div>
            <div>
              <p className="font-semibold text-foreground text-sm">Since 2018</p>
              <p className="text-xs">Trusted Provider</p>
            </div>
          </div>

          {/* All Cards Accepted */}
          <div className="flex items-center gap-3 text-muted-foreground">
            <div className="p-2 rounded-lg bg-accent/10">
              <CreditCard className="h-6 w-6 text-accent" />
            </div>
            <div>
              <p className="font-semibold text-foreground text-sm">All Major Cards</p>
              <p className="text-xs">Accepted</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
